const hexToRgbTuple = (hex: string): [number, number, number] => [
  parseInt(hex.slice(1, 3), 16),
  parseInt(hex.slice(3, 5), 16),
  parseInt(hex.slice(5, 7), 16)
]

export const interpolateColor = (
  from: string,
  to: string,
  t: number
): string => {
  const [r1, g1, b1] = hexToRgbTuple(from)
  const [r2, g2, b2] = hexToRgbTuple(to)
  const mix = (a: number, b: number) => Math.round(a + (b - a) * t)
  return `rgb(${mix(r1, r2)}, ${mix(g1, g2)}, ${mix(b1, b2)})`
}
